exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-resized[data-v-69f16464] {\n  width: 40%;\n  min-width: 420px;\n}", ""]);

// exports
